import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../context/ThemeContext";
import heroBgLight from "../assets/images/hero-bg-light.webp";
import heroBgDark from "../assets/images/hero-bg-dark.webp";

const HeroSection = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const bgImage = isDarkMode ? heroBgDark : heroBgLight;

  return (
    <section
      id="hero"
      className="relative bg-cover bg-top bg-no-repeat h-screen snap-start flex items-center justify-center px-4 md:px-10 text-center text-white"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>
      <div className="relative z-10 max-w-3xl mx-auto pt-16" data-aos="fade-up">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight mb-4">
          {t('hero.title')}
        </h1>
        <p className="text-base sm:text-lg text-white/90 mb-6">
          {t('hero.subtitle')}
        </p>
        <div className="flex justify-center flex-wrap gap-4">
          <a
            href="/download"
            className="bg-white text-primaryAccent text-sm px-5 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
          >
            {t('hero.button.googlePlay')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
